export default __webpack_public_path__ + "static/media/cancel_red.a12d16cf.svg";